import React, { useEffect, useState, useContext } from "react";

import "react-datepicker/dist/react-datepicker.css";
// import "./AdvanceDashboard.css";
import Header from "../../Header/Header";
import "./dashboard.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faGauge, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  getAllData,
  getSingleData,
} from "../../../../utils/apis/Dashborad/Dashborad";
import { Context } from "../../../../utils/context";
import { Form } from "react-bootstrap";
import { getSetup } from "../../../../utils/apis/masters/masters";
import { Permission } from "../../../../utils/permissions";

library.add(fas);

const StatCard = ({ variant, icon, title, rows, footer }) => (
  <div className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-3">
    <div className={variant}>
      <div className="Total-Regis-holder">
        <p className="card_title_text">
          <span className="kpi-icon" aria-hidden="true">
            <FontAwesomeIcon icon={icon} />
          </span>
          {title}
        </p>
        {rows.map(([label, value]) => (
          <div className="user" key={label}>
            <p className="sub-text">{label}</p>
            <p className="sub-text">{value}</p>
          </div>
        ))}
      </div>
      <div className="sub-text-holder">
        <p className="sub-text">{footer}</p>
      </div>
    </div>
  </div>
);

function Table() {

  const { isAllow } = useContext(Context);

  // Graph related

  // Update chart data when dotas changes
  // useEffect(() => {
  // setChartOptions((prevOptions) => ({
  //   ...prevOptions,
  //   series: prevOptions.series.map((series) =>
  //     series.name === "Total Withdrawal" ? { ...series, data: dotas } : series
  //   ),
  // }));
  // }, [dotas]);

  const [data, setData] = useState({});

  const getData = async () => {
    const res = await getAllData("Today");
    await setDataAll(res?.data);

    const singleRes = await getSingleData("Today");
    await setData(singleRes?.data);
  };

  const [selected, setSelected] = useState("Today");
  const [dataAll, setDataAll] = useState({});

  const getDataAll = async (selected) => {
    // {
    //   const res = await getAllData(selected);
    //   await setDataAll(res?.data);
    // }
    const res = await getSingleData(selected);
    await setData(res?.data);
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getDataAll(selected);
  }, [selected]);


  const [setup, setSetup] = useState({});
  const getsetup = async () => {
    const res = await getSetup();
    await setSetup(res?.data);
  };

  useEffect(() => {
    getsetup();
  }, []);
  const convertratedeposite = (amount) => {
    const inr = Number(amount);
    const rate = Number(setup.deposite_exchange_rate);
    const total = (inr * rate).toFixed(2);
    return total;
  };
  const convertratewithdraw = (amount) => {
    const inr = Number(amount);
    const rate = Number(setup?.withdraw_exchange_rate);
    const total = (inr * rate).toFixed(2);
    return total;
  };

  const renderCards = (src) => (
    <div className="row ">
      {isAllow?.includes(Permission.Dashboard.TotalRegistration.name) ? (
        <StatCard
          variant="Total-Regis"
          icon={["fas", "users"]}
          title="Total Registration"
          rows={[
            ["Total User :", src?.register_users],
            ["Active User :", src?.active_register_users],
          ]}
          footer={`Top District : ${src?.top_city?.name ?? ""}`}
        />
      ) : (
        <></>
      )}
      {isAllow?.includes(Permission.Dashboard.ReferralActivity.name) ? (
        <StatCard
          variant="Total-Regis2"
          icon={["fas", "user-shield"]}
          title="Total KYC"
          rows={[
            ["Total Approved :", src?.kyc_approved_users],
            ["Total Rejected :", src?.kyc_reject_users],
          ]}
        />
      ) : (
        <></>
      )}
      {isAllow?.includes(Permission.Dashboard.TotalFunds.name) ? (
        <StatCard
          variant="Total-Regis3"
          icon={["fas", "download"]}
          title="Total Inward Payments"
          rows={[["Total Inward", convertratedeposite(src?.inward_amount || 0)]]}
        />
      ) : (
        <></>
      )}
      {isAllow?.includes(Permission.Dashboard.Withdrawal.name) ? (
        <StatCard
          variant="Total-Regis4"
          icon={["fas", "arrow-up-from-bracket"]}
          title="Total Outward Payments"
          rows={[
            ["Total Capital :", convertratewithdraw(src?.capital_amount || 0)],
          ]}
        />
      ) : (
        <></>
      )}
    </div>
  );

  return (
    <div className="main-advancedashboard">
      <div className="psitionsss">
        <Header icon={faGauge} title={" Dashboard"} link={"/"} />
      </div>

      <section className="AdvanceDashboard">
        <div className="AdvanceDashboardTabs">
          <div className="row justify-content-end me-0 ms-0">
            <div className="col-xxl-12 col-12 p-0">
              <div className="tab-content" id="myTabContent">
                {/* overview tab start */}
                <div
                  className="tab-pane fade show active psitionsss22"
                  id="Overview-tab-pane"
                  role="tabpanel"
                  aria-labelledby="Overview-tab"
                  tabIndex={0}
                >
                  <div className="AdvanceDashboardTabsContent">
                    <div className="top_div">
                      <div className="common_title_div">
                        <p className="inner_text">Daily Activity</p>
                      </div>

                      <Form.Group className="checks_div">
                        <Form.Check
                          type="radio"
                          id="period-today"
                          label="Today"
                          name="radioGroup"
                          value="Today"
                          checked={selected === "Today"}
                          onChange={(e) => setSelected(e.target.value)}
                        />

                        <Form.Check
                          type="radio"
                          id="period-weekly"
                          label="Weekly"
                          name="radioGroup"
                          value="Weekly"
                          checked={selected === "Weekly"}
                          onChange={(e) => setSelected(e.target.value)}
                        />

                        <Form.Check
                          type="radio"
                          id="period-monthly"
                          label="Monthly"
                          name="radioGroup"
                          value="Monthly"
                          checked={selected === "Monthly"}
                          onChange={(e) => setSelected(e.target.value)}
                        />
                      </Form.Group>
                    </div>

                    {renderCards(data)}

                    <div className="divider_div"></div>

                    <div className="common_title_div">
                      <p className="inner_text">Lifetime Activity</p>
                    </div>
                    {renderCards(dataAll)}
                  </div>
                </div>
                {/* overview tab end */}
                {/* ***************************************Graph*********************************** */}
                {/* {isAllow?.includes(Permission.Dashboard.Graph.name) ? (
                  <div className="Graph">
                    <div id="chart">
                      <ReactApexChart
                        options={chartOptions.options}
                        series={chartOptions.series}
                        type="line"
                        height={550}
                      />
                    </div>
                    <div id="html-dist"></div>
                  </div>
                ) : (
                  <></>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Table;
